module.exports = __webpack_public_path__ + "static/4-8e313db1a461a3e1c14543c59cc685f4.svg";